/**
 * Validates emails based on a Regex Pattern
 * @param value Email string that should be validated.
 * @returns A boolean value to indicates if the email address is valid.
 */
export function emailValidation(value: string): boolean {
  const checkedValue =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.exec(
      String(value).toLowerCase(),
    );

  return checkedValue ? true : false;
}
